// extracted by mini-css-extract-plugin
module.exports = {"question":"styles_question__3GIEd","questionRow":"styles_questionRow__sw5ej","answer":"styles_answer__tMWxS"};